const state = {
    summaryNotes: [
    ],
};

const mutations = {
    addOrUpdateSummaryNote(state, newSummaryNote) {
        const existingIndex = state.summaryNotes.findIndex(
            (note) => note.date === newSummaryNote.date
        );

        if (existingIndex !== -1) {
            // Обновить существующую заметку
            state.summaryNotes.splice(existingIndex, 1, newSummaryNote);
        } else {
            // Добавить новую заметку
            state.summaryNotes.push(newSummaryNote);
        }
    },
    removeSummaryNote(state, summaryNoteIndex) {
        state.summaryNotes.splice(summaryNoteIndex, 1);
    },
    setSummaryNotes(state, summaryNotes) {
        state.summaryNotes = summaryNotes;
    },
};

const actions = {
    setSummaryNotes({ commit }, newSummaryNotes) {
        commit("updateSummaryNotes", newSummaryNotes);
    },
    addOrUpdateSummaryNote({ commit }, newSummaryNote) {
        commit("addOrUpdateSummaryNote", newSummaryNote);
    },
    removeSummaryNote({ commit }, summaryNoteIndex) {
        commit("removeSummaryNote", summaryNoteIndex);
    },
    loadSummaryNotes({ commit }, summaryNotesFromApi) {
        commit("setSummaryNotes", summaryNotesFromApi);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
